'use es6';

import { createSelector } from 'reselect';
import EmailType from 'EmailData/enums/EmailType';
import currentEmailDetails from 'EmailData/selectors/details/current/currentEmailDetails';
const currentEmailType = createSelector([currentEmailDetails], emailDetails => {
  return emailDetails.getIn(['primaryEmail', 'emailType'], EmailType.BATCH_EMAIL);
});
export default currentEmailType;